module.exports = __webpack_public_path__ + "img/用户头像-男.33c8fcd4.png";